// =====================================
//
//   Product Controller
//   Author: Gray
//   createtime: 2016 / 08 / 31
//
// =====================================

window.InifECMobileApp.controller("ProductController", ['$scope', '$state', '$timeout', '$rootScope', 
    '$stateParams', 'ProductService', '$WebTitle', '$PreviousState', '$InifECGA', 'UserService',
	function($scope, $state, $timeout, $rootScope, 
        $stateParams, ProductService, $WebTitle, $PreviousState, $InifECGA, UserService) {

        // --------------------------------
        // 上一頁
        // --------------------------------
        var goBack = function() {

            var pdtClass = undefined;

            if($scope.product) {
                if($scope.product.pdtClassURLParam) {
                    pdtClass = $scope.product.pdtClassURLParam;
                } else {
                    pdtClass = $scope.product.pdtClass;
                }
            }
            
            var backState = $PreviousState.getProductPrevious(pdtClass);
            $PreviousState.goBack(backState);
        }

        // --------------------------------
        // [private] 取得商品資訊
        // --------------------------------
        var getProductInfo = function() {

            $scope.isLoading = false;
            ProductService.getProductInfo($scope.productid).then(function(result){
                if (result) {
                    $timeout(function(){
                        $scope.product = result;
                        var title = $scope.product.name + " | inif印衣服，巧昱服飾設計有限公司";
                        $WebTitle.setWebTitle(title);

                        var ga_info = {
                            productid: $scope.productid,
                            name: $scope.product.name,
                            mrscid: (UserService.user && UserService.user.mrscid) ? UserService.user.mrscid : 'visitor',
                            pdtclass: $scope.product.pdtClass,
                            pdtClassName: $scope.product.pdtClassName,
                            from: $scope.fromState,
                        }

                        $InifECGA.eventTrack('product', 'view', ga_info.productid);
                        $InifECGA.eventTrack('product', 'view_with_name', ga_info.name);
                        $InifECGA.eventTrack('product', 'view_with_mrscid', ga_info.mrscid);
                        $InifECGA.eventTrack('product', 'view_with_pdtclass', ga_info.pdtclass);
                        $InifECGA.eventTrack('product', 'view_with_pdtclassname', ga_info.pdtClassName);
                        $InifECGA.eventTrack('product', 'view_from', ga_info.from);
                        $InifECGA.eventTrack('product', 'view_with_fullinfo', JSON.stringify(ga_info));
                    });
                    
                } else {
                    $scope.isError = true;
                }
                $scope.isLoading = false;
            }, function(error){
                $scope.isError = true;
                $scope.isLoading = false;
            });
        }

        let setPreview = function (idx) {

            $scope.previewIndex = idx;
        }

        // ------------------------------
        // getSelectImage
        // ------------------------------
        var getSelectImage = function() {

            var src = '';

            if($scope.product && Array.isArray($scope.product.covers) && $scope.product.covers.length > 0) {

                var index = $scope.previewIndex || 0;

                src = $scope.product.covers[index];
            }

            return src;
        }

        // ------------------------------
        // getCoverImage
        // ------------------------------
        var getCoverImage = function(cover) {

            return cover;
        }

        var init = function() {

            getProductInfo();
        }

        //==========================
        //  Events
        //==========================
        $scope.$on("$stateChangeStart", function(event, toState, toParams, fromState, fromParams) {

            $scope.fromState = fromState.name;
        });

        //==========================
        //  Members
        //==========================

        $scope.productid = $stateParams.productid;
        $scope.isLoading = false;
        $scope.isError = false;
        $scope.product = undefined;
        $scope.className = undefined;
        $scope.price = 0;
        $scope.fromState = '';
        $scope.previewIndex = 0;

        //==========================
        //  Methods
        //==========================
        $scope.goBack = goBack; // 上一頁
        $scope.addToShoppingCart;
        $scope.getViewPrice;
        $scope.isOrderItemSpecError;
        $scope.setPreview = setPreview;
        $scope.getSelectImage = getSelectImage;
        $scope.getCoverImage = getCoverImage;

        //==========================
        //  Init
        //==========================
        init();
	}
]);